module.exports = __webpack_public_path__ + "static/monitor-screen-4d4ada126d7d61d2f7cc3f209d714c11.png";